import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { PerfectScrollbarPlugin } from 'vue3-perfect-scrollbar';
import VueApexCharts from 'vue3-apexcharts';
import VueTablerIcons from 'vue-tabler-icons';
import '@mdi/font/css/materialdesignicons.css';
import '@/scss/style.scss';
import {
  BLUE_THEME,
} from "@/theme/LightTheme";
import { DARK_BLUE_THEME } from "@/theme/DarkTheme";
export default defineNuxtPlugin((nuxtApp) => {
  const vuetify = createVuetify({
    components,
    directives,
    theme: {
      defaultTheme: "BLUE_THEME",
      themes: {
        BLUE_THEME,
        DARK_BLUE_THEME,
      },
    },
    defaults: {
      VBtn: {},
      VCard: {
          rounded: 'md'
      },
      VTextField: {
          rounded: 'lg'
      },
      VTooltip: {
          location: 'top'
      }
  }
  });
  nuxtApp.vueApp.use(vuetify);
  nuxtApp.vueApp.use(PerfectScrollbarPlugin);
  nuxtApp.vueApp.use(VueApexCharts);
  nuxtApp.vueApp.use(VueTablerIcons);
  // Dipakai device preview agar breakpoint ikut saat ganti Desktop/Tablet/HP
  nuxtApp.provide('vuetifyDisplay', vuetify.display);
  nuxtApp.provide('vuetify', vuetify);
});
